module.exports = __webpack_public_path__ + "media/images/categories/headers/science-afebab07bb15371144beea78b8ebb21c.jpg";